export const actions = {
  BIBFONDOFAMILIA_LOAD_REQUESTED: 'BIBFONDOFAMILIA_LOAD_REQUESTED',
  BIBFONDOFAMILIA_LOAD_SUCCEEDED: 'BIBFONDOFAMILIA_LOAD_SUCCEEDED',
  BIBFONDOFAMILIA_LOAD_FAILED: 'BIBFONDOFAMILIA_LOAD_FAILED',

  BIBFONDOFAMILIA_LOAD_BY_ID_REQUESTED: 'BIBFONDOFAMILIA_LOAD_BY_ID_REQUESTED',
  BIBFONDOFAMILIA_LOAD_BY_ID_SUCCEEDED: 'BIBFONDOFAMILIA_LOAD_BY_ID_SUCCEEDED',
  BIBFONDOFAMILIA_LOAD_BY_ID_FAILED: 'BIBFONDOFAMILIA_LOAD_BY_ID_FAILED',

  BIBFONDOFAMILIA_FILTERED_LOAD_REQUESTED: 'BIBFONDOFAMILIA_FILTERED_LOAD_REQUESTED',
  BIBFONDOFAMILIA_FILTERED_LOAD_SUCCEEDED: 'BIBFONDOFAMILIA_FILTERED_LOAD_SUCCEEDED',
  BIBFONDOFAMILIA_FILTERED_LOAD_FAILED: 'BIBFONDOFAMILIA_FILTERED_LOAD_FAILED',

  BIBFONDOFAMILIA_INSERT_REQUESTED: 'BIBFONDOFAMILIA_INSERT_REQUESTED',
  BIBFONDOFAMILIA_INSERT_SUCCEEDED: 'BIBFONDOFAMILIA_INSERT_SUCCEEDED',
  BIBFONDOFAMILIA_INSERT_FAILED: 'BIBFONDOFAMILIA_INSERT_FAILED',

  BIBFONDOFAMILIA_UPDATE_REQUESTED: 'BIBFONDOFAMILIA_UPDATE_REQUESTED',
  BIBFONDOFAMILIA_UPDATE_SUCCEEDED: 'BIBFONDOFAMILIA_UPDATE_SUCCEEDED',
  BIBFONDOFAMILIA_UPDATE_FAILED: 'BIBFONDOFAMILIA_UPDATE_FAILED',

  BIBFONDOFAMILIA_UPDATE_AREAS_REQUESTED: 'BIBFONDOFAMILIA_UPDATE_AREAS_REQUESTED',
  BIBFONDOFAMILIA_UPDATE_AREAS_SUCCEEDED: 'BIBFONDOFAMILIA_UPDATE_AREAS_SUCCEEDED',
  BIBFONDOFAMILIA_UPDATE_AREAS_FAILED: 'BIBFONDOFAMILIA_UPDATE_AREAS_FAILED',

  DELETE_BIBFONDOFAMILIA_REQUESTED: 'DELETE_BIBFONDOFAMILIA_REQUESTED',
  DELETE_BIBFONDOFAMILIA_SUCCEEDED: 'DELETE_BIBFONDOFAMILIA_SUCCEEDED',
  DELETE_BIBFONDOFAMILIA_FAILED: 'DELETE_BIBFONDOFAMILIA_FAILED',

  UPDATED_FONDO_FAMILIA_FILE: 'UPDATED_FONDO_FAMILIA_FILE',
  INSERTED_FONDO_FAMILIA_FILE: 'INSERTED_FONDO_FAMILIA_FILE',
  DELETED_FONDO_FAMILIA_FILE: 'DELETED_FONDO_FAMILIA_FILE',
}

export const getBibfondofamiliaAction = dispatch => {
  dispatch({
    type: actions.BIBFONDOFAMILIA_LOAD_REQUESTED,
  })
}

export const getBibfondofamiliaByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBFONDOFAMILIA_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const getBibfondofamiliaFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBFONDOFAMILIA_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const insertBibfondofamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFONDOFAMILIA_INSERT_REQUESTED,
    payload,
  })
}

export const updateBibfondofamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFONDOFAMILIA_UPDATE_REQUESTED,
    payload,
  })
}

export const updateBibfondofamiliaAreasAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFONDOFAMILIA_UPDATE_AREAS_REQUESTED,
    payload,
  })
}

export const deleteBibfondofamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETE_BIBFONDOFAMILIA_REQUESTED,
    payload,
  })
}

export const updatedFondoFamiliaFileAction = (dispatch, payload) => {
  dispatch({
    type: actions.UPDATED_FONDO_FAMILIA_FILE,
    payload,
  })
}

export const insertedFondoFamiliaFileAction = (dispatch, payload) => {
  dispatch({
    type: actions.INSERTED_FONDO_FAMILIA_FILE,
    payload,
  })
}

export const deletedFondoFamiliaFileAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETED_FONDO_FAMILIA_FILE,
    payload,
  })
}
